import { pathOr } from 'ramda';
import { muiBankTheme } from '../theme';
const curryGet = (theme) => {
    const getPath = (path) => {
        const getValue = value => {
            const parts = path.split('.');
            const pathWithValue = [...parts, value];
            return pathOr('', pathWithValue, theme);
        };
        return getValue;
    };
    return getPath;
};
const composeGetter = (path) => {
    const withValue = (value) => {
        const withTheme = ({ theme }) => {
            return curryGet(theme)(path)(value);
        };
        return withTheme;
    };
    return withValue;
};
const composeMediaGetter = (key) => {
    const withMediaValue = (...args) => {
        const withTheme = ({ theme }) => {
            const fn = theme.media[key];
            /**
             * For some reason, with `fn(...args)` TS cannot infer that the correct
             * args are being passed
             */
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return fn(...args);
        };
        return withTheme;
    };
    return withMediaValue;
};
const mediaGetterFactory = () => {
    const keys = Object.keys(muiBankTheme.media);
    return keys.reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: composeMediaGetter(key) })), {});
};
const gettersFactory = () => {
    const keys = Object.keys(muiBankTheme);
    return keys.reduce((acc, key) => {
        return Object.assign(Object.assign({}, acc), { [key]: composeGetter(key) });
    }, {});
};
const get = Object.assign(Object.assign({}, gettersFactory()), { media: mediaGetterFactory() });
export { curryGet };
export default get;
//# sourceMappingURL=getters.js.map